import React from 'react';

export const NoAvailableMenuItems = () => {
  return (
    <div className="paddedContentWrapper" style={{ paddingBottom: '16px' }}>
      <div className="paddedContent">
        No menu items are available for order at this time.
      </div>
    </div>
  );
};
